/**
 * MarketingDashboardShell — W48 /dashboards/marketing route entry point.
 *
 * Wraps the W48 marketing dashboard sections in OperatorShell,
 * following the W46 shell pattern from MarketingView.tsx.
 *
 * Six sections per W48 spec:
 *   (A) FunnelVisual
 *   (B) MarketingCalendar
 *   (C) HookLibrary
 *   (D) LinkedInDripCard
 *   (E) MarketingActivityAudit
 *   (F) AccountabilityPack
 */

import OperatorShell from "@/components/operator/OperatorShell";
import MarketingDashboardPage from "./marketing";

export default function MarketingDashboardShell() {
  return (
    <OperatorShell
      breadcrumbs={[
        { label: "Home", href: "/" },
        { label: "Dashboards", href: "/dashboards/charts" },
        { label: "Marketing" },
      ]}
      pageTitle="Marketing Dashboard"
      pageMeta="Funnel — Calendar — Hooks — LinkedIn — Audit — Accountability"
    >
      <div className="mx-auto max-w-6xl px-0 py-4">
        <MarketingDashboardPage />
      </div>
    </OperatorShell>
  );
}
